import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { NoSsr } from '@cian/react-utils';
import { Responsive } from '@cian/ui-kit';
import { UiKitRoot } from '@cian/ui-kit/root';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { CatProfilingModalContainer } from '../CatProfilingModalContainer';
import { ChatsNotificationsContainer } from '../ChatsNotificationsContainer';
import { CianGptPopupContainer } from '../CianGptPopupContainer';
import { CookiesNotificationContainer } from '../CookiesNotificationContainer';
import { CookiesNotificationContainerV2 } from '../CookiesNotificationContainerV2';
import { FeedbackFormContainer } from '../FeedbackFormContainer';
import { HeaderLoadable as Header } from '../HeaderContainer';
import { MergeNotificationContainer } from '../MergeNotificationContainer';
import { OnboardingContainer } from '../OnboardingContainer';
import { PinnedButtonContainer } from '../PinnedButtonContainer';
import { UnreadMessagesLoader } from '../UnreadMessagesLoader';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
    microfrontendsRegistry,
    config,
  } = context;
  const { noResize } = reduxStore.getState();

  const cookieAgreementV2Enabled = config.get<boolean>('header-frontend.cookieAgreementV2.Enabled') ?? false;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType || 'phone'} useStaticDeviceType={noResize}>
          <Provider store={reduxStore}>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <UnreadMessagesLoader />
              <MergeNotificationContainer />
              {cookieAgreementV2Enabled ? <CookiesNotificationContainerV2 /> : <CookiesNotificationContainer />}
              <Header />
              <FeedbackFormContainer />
              <ChatsNotificationsContainer />
              <CianGptPopupContainer />
              <NoSsr>
                <CatProfilingModalContainer />
                <Responsive tablet phone>
                  <PinnedButtonContainer />
                </Responsive>
                <OnboardingContainer />
              </NoSsr>
            </MicrofrontendProvider>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
